<template>
  <div class="bind-mask" v-if="showModal">
    <div class="bind-sheet">
      <button class="close" @click="cancelBind">×</button>
      <h3>{{ isEn ? 'Add Inviter' : '添加邀请人' }}</h3>
      <input v-model="inviterAddressInput" :placeholder="isEn ? 'Please enter invite code' : '请输入邀请码'">
      <button class="confirm" :disabled="submitting" @click="bindInviter">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'BindInviterModal',
  data() {
    return { inviterAddressInput: '', submitting: false, submitStep: '' };
  },
  computed: {
    ...mapState({ showModal: s => s.showBindInviterModal }),
    ...mapGetters(['getWalletAddress', 'getInviteCode']),
    isEn() { return this.$i18n && this.$i18n.locale === 'en'; },
    buttonText() {
      if (!this.submitting) return this.isEn ? 'Confirm' : '确认';
      if (this.submitStep === 'sign') return this.isEn ? 'Confirm signature in wallet...' : '请在钱包确认签名...';
      if (this.submitStep === 'bind') return this.isEn ? 'Binding...' : '绑定中...';
      return this.isEn ? 'Processing...' : '处理中...';
    }
  },
  watch: {
    showModal(v) {
      if (v && this.getInviteCode && !this.inviterAddressInput) this.inviterAddressInput = this.getInviteCode;
    }
  },
  methods: {
    cancelBind() {
      this.$store.commit('setShowBindInviterModal', false);
      this.inviterAddressInput = '';
    },
    async bindInviter() {
      if (this.submitting) return;
      const inviteCode = this.inviterAddressInput.trim() || this.getInviteCode || '';
      if (!inviteCode) return this.toast(this.isEn ? 'Invite code is required.' : '请填写邀请码，没有邀请码无法注册绑定', 'error');
      this.submitting = true;
      this.submitStep = 'prepare';
      try {
        let address = this.getWalletAddress;
        if (!address && window.ethereum) {
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          if (accounts && accounts[0]) {
            address = accounts[0];
            this.$store.dispatch('updateWalletAddress', address);
          }
        }
        if (!address) return this.toast(this.isEn ? 'Please connect your wallet first.' : '请先连接钱包', 'info');
        this.submitStep = 'sign';
        await this.$store.dispatch('ensureDogeAuth');
        this.submitStep = 'bind';
        const body = { address };
        if (inviteCode) body.inviteCode = inviteCode;
        let r = await this.$axios.post('/api/wallet/address/upload', body);
        if ([401, 999].includes(Number(r.data && r.data.code))) {
          this.$store.commit('setDogeAuthToken', null);
          this.submitStep = 'sign';
          await this.$store.dispatch('ensureDogeAuth', { force: true });
          this.submitStep = 'bind';
          r = await this.$axios.post('/api/wallet/address/upload', body);
        }
        if (Number(r.data.code) === 1 || Number(r.data.code) === 200) {
          this.toast(this.isEn ? 'Bound successfully.' : '绑定成功', 'success');
          this.$store.commit('markInviterBound', address);
          this.$store.commit('setShowBindInviterModal', false);
          this.$store.dispatch('fetchUserDetails');
          this.inviterAddressInput = '';
        } else {
          this.toast(r.data.message || r.data.msg || (this.isEn ? 'Binding failed.' : '绑定失败'), 'error');
        }
      } catch (e) {
        this.toast((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || (this.isEn ? 'Network error. Binding failed.' : '网络错误，绑定失败'), 'error');
      } finally {
        this.submitting = false;
        this.submitStep = '';
      }
    },
    toast(t, type = 'info') {
      this.$messageDialog ? this.$messageDialog.alert(t, this.isEn ? 'Info' : '提示', type) : alert(t);
    }
  }
};
</script>

<style scoped>
.bind-mask{position:fixed;inset:0;background:rgba(0,0,0,.72);z-index:3000;display:flex;align-items:flex-end;justify-content:center}.bind-sheet{position:relative;width:100%;max-width:520px;background:#10212b;border-radius:24px 24px 0 0;padding:30px 18px 34px;box-shadow:0 -8px 30px rgba(0,0,0,.35)}.close{position:absolute;right:18px;top:16px;width:34px;height:34px;border:0;border-radius:50%;background:#f6a21a;color:#201100;font-size:23px;font-weight:900}.bind-sheet h3{margin:0 0 24px;text-align:center;color:#fff;font-size:20px}.bind-sheet input{width:100%;height:50px;border:0;border-radius:14px;background:#05090d;color:#fff;padding:0 15px;outline:none}.confirm{width:100%;height:50px;border:0;border-radius:999px;background:linear-gradient(90deg,#f19b14,#ffc84d);color:#211300;font-weight:800;font-size:16px;margin-top:22px}.confirm:disabled{opacity:.65}
</style>
